export enum CommercialPaymentActionType {
	FETCH_ALL_PAYMENTS = 'FETCH_ALL_PAYMENTS',
	STORE_ALL_PAYMENTS = 'STORE_ALL_PAYMENTS',
	ERROR_ALL_PAYMENTS = 'ERROR_ALL_PAYMENTS',

	FETCH_PROJECT_AUTOCOMPLETE = 'FETCH_PROJECT_AUTOCOMPLETE',
	ERROR_FETCH_PROJECT_AUTOCOMPLETE = 'ERROR_FETCH_PROJECT_AUTOCOMPLETE',
	STORE_PROJECT_AUTOCOMPLETE = 'STORE_PROJECT_AUTOCOMPLETE',

	FETCH_CUSTOMER_SLIPS = 'FETCH_CUSTOMER_SLIPS',
	STORE_CUSTOMER_SLIPS = 'STORE_CUSTOMER_SLIPS',
	ERROR_CUSTOMER_SLIPS = 'ERROR_CUSTOMER_SLIPS',

	FETCH_PAYMENT_SLIPS = 'FETCH_PAYMENT_SLIPS',
	STORE_PAYMENT_SLIPS = 'STORE_PAYMENT_SLIPS',
	ERROR_PAYMENT_SLIPS = 'ERROR_PAYMENT_SLIPS',

	APPROVE_PAYMENT = 'APPROVE_PAYMENT',

	CREATE_GST_INVOICE = 'CREATE_GST_INVOICE',
	STORE_GST_INVOICE = 'STORE_GST_INVOICE',
	ERROR_GST_INVOICE = 'ERROR_GST_INVOICE',

	FETCH_GST_INVOICE = 'FETCH_GST_INVOICE'
}
